/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-20 15:03:38
 * @LastEditTime: 2025-04-23 09:45:03
 * @LastEditors: ywj@originqc.com
 */

export const payList = [
  {
    value: 0,
    label: '全部'
  },
  {
    value: 1,
    label: '未开票'
  },
  {
    value: 3,
    label: '已开票'
  },
  {
    value: 4,
    label: '拒绝开票'
  },
]

export const titleList = [
  {
    name: '商品',
    width: 309
  },
  {
    name: '开票金额',
    width: 80
  },
  {
    name: '发票类型',
    width: 100
  },
  {
    name: '发票抬头',
    width: 110
  },
  {
    name: '开票日期',
    width: 100
  },
  {
    name: '开票状态',
    width: 100,
    list: payList
  },
  
  {
    name: '操作',
    width: 110
  }
]